import { findNode } from '@/util/action-types';
import cloneDeep from 'lodash/cloneDeep';

const nodeDrop = ({ getters, dispatch }, { options }) => {
  const nodeId = getters['MOVING_NODE_ID'];
  const startSettings = getters['START_SETTINGS'];
  const nodeList = cloneDeep(getters['NODES']);
  const selectedNodeOptions = getters['SELECTED_NODE_OPTIONS'];

  const node = findNode(nodeList, nodeId);

  const { index: selectedNodeIndex, parentNode: selectedNodeParentNode } =
    selectedNodeOptions;

  const {
    index: insertIndex,
    parentNode: insertParentNode,
    branch: insertBranch,
  } = options;

  const isEventType =
    startSettings.trigger_type === 'event' && startSettings.trigger_subtype;
  if (!selectedNodeParentNode && selectedNodeIndex === undefined && isEventType)
    return;

  let sameIndex =
    selectedNodeIndex === insertIndex || selectedNodeIndex + 1 === insertIndex;

  let sameParent = false;

  if (selectedNodeParentNode && insertParentNode) {
    if (insertParentNode.action_type === 'conditional') {
      sameParent =
        selectedNodeParentNode.id === insertParentNode.id &&
        node.path.branch === insertBranch;
    } else {
      sameParent = selectedNodeParentNode.id === insertParentNode.id;
    }
  } else if (!selectedNodeParentNode && !insertParentNode) {
    sameParent = true;
  }

  if (!(sameParent && sameIndex)) {
    const adjustedOptions = { ...options };
    if (sameParent && selectedNodeIndex < insertIndex) {
      adjustedOptions.index = insertIndex - 1;
    }

    dispatch('removeNode', node);
    dispatch('insertNode', { node, options: adjustedOptions });
  }
};

export default nodeDrop;
